
















import { Component, Vue } from 'vue-property-decorator'
import PageHeader from '@/layouts/page-header/index.vue'
import PageSideBar from '@/layouts/page-side-bar/index.vue'
import PageTags from '@/layouts/page-tags/index.vue'
import TagsView from '@/layouts/TagsView/index.vue'
@Component({ name: 'Layout', components: { PageHeader, PageSideBar, PageTags, TagsView } })
export default class AppLayout extends Vue {

}

